export default __webpack_public_path__ + "static/media/icon-bell-grey.13ad683b.svg";